export const exportArgosJobHistoryExcel = (jobId, jobHistory) => ({
    dataExport: jobHistory,
    filename: `argos_job_${jobId}_job_history`,
    parseData: (entry) => [
        entry.ts || '',
        entry.state || '',
    ],
    path: 'events.argosJobs.index.path',
    titles: [
        'Date/time',
        'Status',
    ],
});
